<template>
  <div class="wrapper">
    <div class="select-wrapper">
      <div>筛选</div>
      <div class="select-item">
        <i class="icon-down lMar10"></i>
        <select name id v-model="year" @change="getList()">
          <option value>全部</option>
          <option :value="item.value" v-for="(item,index) in yearList" :key="index">{{item.lable}}</option>
        </select>
      </div>
      <div class="select-item">
        <i class="icon-down lMar10"></i>
        <select name id v-model="month" @change="getList()">
          <option value>全部</option>
          <option :value="item.value" v-for="(item,index) in monthList" :key="index">{{item.lable}}</option>
        </select>
      </div>
    </div>
    <div class="journal-list">
      <div class="journal-two-list" v-for="(item,index) in journalList" :key="'jon'+index">
        <div
          class="journal-item"
          v-for="(item_2,index_2) in item"
          :key="'journal'+index_2"
          @touchend="toPage({name:'JournalDetail',query:{id:item_2.id,year:item_2.year,num:item_2.num}})"
        >
          <div class="journal-title">第{{item_2.num}}期</div>
          <div class="journal-text">{{item_2.publish_date}}</div>
        </div>
      </div>
    </div>
    <model-page :dataObj="ariList" @nextPage="nextPage"></model-page>
  </div>
</template>
<script>
import { getYears, getMonths } from "@/filter";
import ModelPage from "@/components/common/ModelPage";
import { userApi } from "@/api/user.js";
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      yearList: [],
      monthList: [],
      year: "",
      page: 1,
      count: 12,
      month: "",
      ariList: [],
      journalList: []
    };
  },
  mounted() {
    this.yearList = getYears(); //获取年份   不传值表示  从今年到1990
    this.monthList = getMonths();
    this.getJournalList();
  },
  computed: {
    ...mapGetters(["touchflg"])
  },
  methods: {
    toPage(url) {
     if (this.touchflg) {
        this.$router.push(url);
      }
    },
    getJournalList() {
      const params = {
        year: this.year,
        month: this.month,
        page: this.page,
        count: this.count
      };
      userApi.getjournallistList(params).then(res => {
        this.ariList = res.data;
        if (this.ariList.total == "1") {
          this.$router.push({
            name: "JournalDetail",
            query: {
              id: this.ariList.list[0].id,
              year: this.ariList.list[0].year,
              num: this.ariList.list[0].num
            }
          });
        }
        var result = [];
        var chunk = 2; //每4个分一组
        for (var i = 0, j = res.data.list.length; i < j; i += chunk) {
          result.push(res.data.list.slice(i, i + chunk));
        }
        this.journalList = result;
      });
    },
    getList() {
      this.getJournalList();
    },
    nextPage(pageNo) {
      this.page = pageNo;
      this.getJournalList();
      // 重新加载列表
    }
  },
  components: {
    ModelPage
  }
};
</script>
<style lang="less" scoped>
@import "./../../common/minix.less";
.wrapper {
  .select-wrapper {
    width: 100%;
    background: #fff;
    font-size: 24 / @rem;
    height: 100 / @rem;
    display: flex;
    align-items: center;
    padding: 0 20 / @rem;
    .select-item {
      width: 200 / @rem;
      height: 60 / @rem;
      line-height: 60 / @rem;
      position: relative;
      margin: 0 10 / @rem;
    }
    .select-item select {
      appearance: none;
      -moz-appearance: none;
      -webkit-appearance: none;
    }
    .select-item select::-ms-expand {
      display: none;
    }
    .select-item select {
      width: 100%;
      height: 60 / @rem;
      line-height: 60 / @rem;
      border: none;
      outline: none;
      border: 1 / @rem solid #dfdfdf;
      border-radius: 4 / @rem;
      box-sizing: border-box;
      padding: 0 10 / @rem;
      color: #000;
      font-size: 24 / @rem;
      background: #fff;
    }
    .select-item select option {
      font-size: 24 / @rem;
    }
    .icon-down {
      position: absolute;
      top: 18 / @rem;
      right: 8 / @rem;
      display: block;
      width: 15 / @rem;
      height: 24 / @rem;
      background: url("/static/img/select.png") no-repeat center;
      background-size: 15 / @rem 24 / @rem;
    }
  }
  .journal-two-list {
    width: 715 / @rem;
    height: 450 / @rem;
    margin: 0 auto;
    padding: 40 / @rem 0;
    box-sizing: border-box;
    background: url(/static/img/jounal-shadow.png) no-repeat center bottom;
    background-size: 715 / @rem 94 / @rem;
    display: flex;
    .journal-item {
      width: 50%;
      height: 341 / @rem;
      background: url(/static/img/book.png) no-repeat center center;
      background-size: 258 / @rem 341 / @rem;
      color: #fff;
      text-align: center;
      .journal-title {
        margin-top: 210 / @rem;
        font-size: 30 / @rem;
        line-height: 50 / @rem;
      }
      .journal-text {
        font-size: 28 / @rem;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Journal/list.vue